/**
 * Model to hold a win type winType.
 */
import { DivisionProfile } from '@reg/shared/model/division-profile.model';

export class WinType {
    public static NO_CONTEST: string = 'NC';
    public static FORFEIT: string = 'FOR';
    public static BYE: string = 'BYE';
    public static MEDICAL_FORFEIT: string = 'M FOR';
    public static DEFAULT: string = 'DEF';

    public id: string;
    public name: string;
    public description: string;
    public sequence: number;
    public winnerTeamPoints: number;
    public loserTeamPoints: number;
    public divisionProfile: DivisionProfile;

    public clone(): WinType {
        const clone: WinType = new WinType();
        clone.id = this.id;
        clone.name = this.name;
        clone.description = this.description;
        clone.sequence = this.sequence;
        clone.winnerTeamPoints = this.winnerTeamPoints;
        clone.loserTeamPoints = this.loserTeamPoints;
        clone.divisionProfile = this.divisionProfile && this.divisionProfile.clone();
        return clone;
    }

    public formatDescriptionName(): string {
        if (this.description && this.name) {
            return `${this.description} (${this.name})`;
        } if (this.description) {
            return this.description;
        }

        return this.name;
    }

    /**
     * Deserialize to a json api format
     */
    public deserialize(json: Object, included: Object[]): WinType {
        const data: Object = json['data'] || json;
        const attrs: Object = data['attributes'];
        const relationships: Object = data['relationships'] || [];
        included = included || json['included'];

        this.id = data['id'];
        this.name = attrs['name'];
        this.description = attrs['description'];
        this.sequence = attrs['sequence'];
        this.winnerTeamPoints = attrs['winnerTeamPoints'];
        this.loserTeamPoints = attrs['loserTeamPoints'];
        this.divisionProfile = new DivisionProfile(attrs['divisionProfileId']);

        const divProfileRelationship: Object = relationships['divisionProfile'];
        if (divProfileRelationship &&
            included &&
            divProfileRelationship['data'] &&
            divProfileRelationship['data']['id']) {
            const divProfileId: string = divProfileRelationship['data']['id'];
            const divProfileInclude: Object =
                included.filter((i: Object) => i['type'] === 'divisionProfile' && i['id'] === divProfileId)[0];

            if (divProfileInclude) {
                this.divisionProfile = (new DivisionProfile()).deserialize(divProfileInclude, included);
            }
        }

        return this;
    }
}
